import { Outlet } from "react-router-dom";

function PublicRoute() {
	return <Outlet />;
}

export { PublicRoute };
